// refresh CSRF tokens
function showColumnSortSpinner(column) {
  var th = document.querySelector('th.col-' + column);
  if (!th) return;
  var indicator = th.querySelector(".ajax-indicator");
  if (indicator) indicator.style.display = 'inline-block';
  var sortIcon = th.querySelector(".sort-icon");
  if (sortIcon) sortIcon.style.display = 'none';
}

var refreshCSRFTokens = function() {
  console.log("refreshCSRF");
  const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  document.querySelectorAll('form input[name="authenticity_token"]').forEach((el) => {
    el.value = token;
  });
}

window.refreshCSRFTokens = refreshCSRFTokens;

// Action-cached pages bake a stale authenticity_token into form HTML. Refresh
// every form's token from the (always-fresh) layout meta tag right before any
// submit. Capture phase so this runs before the browser serializes the form.
// Replaces the global $(document).ajaxComplete(refreshCSRFTokens) handler that
// was removed in the jQuery migration (commit 87b18dbb7).
document.addEventListener('submit', function() {
  refreshCSRFTokens();
}, true);

document.addEventListener('DOMContentLoaded', function() {

  document.addEventListener('click', function(e) {
    if (!e.target) return;
    var dfcBtn = e.target.closest('.btn-toggle-dfc');
    if (dfcBtn) {
      var card = e.target.closest(".price-card-dfc");
      if (!card) return;
      var toggleEl = e.target.closest("[data-bs-toggle=button]");
      if (toggleEl && toggleEl.classList.contains("active")) {
        card.classList.add("active");
      } else {
        card.classList.remove("active");
      }
    }
  });

  var jwtBtn = document.querySelector(".btn-show-jwt");
  if (jwtBtn) {
    jwtBtn.addEventListener('click', function() {
      var jwt = document.getElementById("jwt");
      if (jwt) jwt.type = "text";
    });
  }

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.matches('.btn-copy-to-clipboard')) return;
    var scope = e.target.closest(".copy-to-clipboard-scope");
    if (!scope) return;
    var target = scope.querySelector(e.target.dataset.target);
    if (!target) return;
    if (target.type === "password") {
      target.type = "text";
    }
    target.select();
    document.execCommand("copy");
    if (e.target.dataset.messageContainer) {
      var messageContainer = scope.querySelector(e.target.dataset.messageContainer);
      if (messageContainer) {
        messageContainer.innerHTML = "<div class='alert alert-info'>" + e.target.dataset.message + "</div>";
      }
    }
  });

  var authForm = document.querySelector(".layout-auth-identity-form");
  if (authForm) {
    authForm.addEventListener('submit', function() {
      var emailField = authForm.querySelector('.layout-auth-identity-form-email');
      if (emailField) emailField.value = emailField.value.toLowerCase();
    });
  }

  var sidebarClose = document.getElementById("layout-scoops-sidebar-pop-close");
  if (sidebarClose) {
    sidebarClose.addEventListener('click', function() {
      Cookies.set('layout-sidebar-pop-disable', 'true', { expires: 3650, path: '/' });
      var sidebar = document.getElementById('layout-scoops-sidebar-pop');
      if (sidebar) sidebar.style.display = 'none';
    });
  }

  var popDisable = Cookies.get('layout-sidebar-pop-disable');
  if (popDisable === undefined) {
    var sidebarPop = document.getElementById("layout-scoops-sidebar-pop");
    if (sidebarPop) sidebarPop.classList.remove("hidden");
  }

  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest('.search-trigger')) return;
    e.preventDefault();
    document.querySelectorAll('.cd-morph-dropdown').forEach(function(el) {
      el.classList.remove("nav-open");
    });
    var searchForm = document.querySelector('.layout-search-form');
    if (searchForm) searchForm.classList.toggle('active');
    var searchInput = document.querySelector('.layout-search-input-field');
    if (searchInput) searchInput.focus();
  });

  document.querySelectorAll("#layout-show-submenu").forEach(function(el) {
    var target = "#layout-submenu-" + el.dataset.target;
    var submenu = document.querySelector(target);
    if (submenu) submenu.classList.add("show");
    var mainContent = document.querySelector(".cd-main-content");
    if (mainContent) mainContent.classList.add("cd-main-content-with-submenu");
  });

  /* When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar */
  var prevScrollpos = window.pageYOffset;
  var nav = document.getElementById("main-navigation");
  window.onscroll = function() {
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
      if (!nav) { prevScrollpos = currentScrollPos; return; }
      if (window.scrollY == 0) {
        nav.classList.remove("nav-hidden");
        nav.classList.remove("nav-fixed");
      } else {
        nav.classList.add("nav-fixed");
        nav.classList.remove("nav-hidden");
      }
    } else if (window.scrollY > 122) {
      if (nav) {
        nav.classList.add("nav-hidden");
        nav.classList.remove("nav-fixed");
      }
    }
    prevScrollpos = currentScrollPos;
  }

});


function popout(url) {
  window.open(url, "_blank", "toolbar=no,menubar=no,status=no,resizeable=no,location=no");
}
